export default __webpack_public_path__ + "static/media/List.218f0e24.png";